import { Button, Modal, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { getLatestUnseenRelease, markReleaseViewed, listReleases } from "./release.service";
import moment from "moment";

type ReleaseItem = {
  module: string;
  type: "Feature" | "Fix" | "Improvement";
  description: string;
};

const typeColor = (t: string) => {
  switch (t) {
    case "Feature":
      return "green";
    case "Fix":
      return "volcano";
    default:
      return "blue";
  }
};

const ReleaseNotesModal: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [release, setRelease] = useState<any>(null);

  useEffect(() => {
    // We do not auto-call here; parent will call show check by dispatching a global event
    const handler = async () => {
      try {
        const res: any = await getLatestUnseenRelease();
        console.log(res, 'res')
        if (res?.data?.data) {
          setRelease(res.data.data);
          setVisible(true);
        }
      } catch (err) {
        // ignore
      }
    };
    window.addEventListener("rp:checkRelease", handler as any);
    return () => window.removeEventListener("rp:checkRelease", handler as any);
  }, []);

  const handleClose = async () => {
    setVisible(false);
    if (release?.id) {
      try {
        await markReleaseViewed(release.id);
      } catch (err) {
        // ignore
      }
    }
  };

  if (!release) return null;

  const columns = [
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (t: any) => <Tag color={typeColor(t)}>{t}</Tag>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (d: string) => <div style={{ whiteSpace: "pre-wrap" }}>{d}</div>,
    },
  ];

  const dataSource = (release?.items || []).map((it: any, idx: number) => ({
    key: idx,
    module: it.moduleName,
    type: it.changeType,
    description: it.description,
  }));

  return (
    <Modal
      open={visible}
      centered
      width={800}
      title={`What's New — ${release?.version} (${moment(release?.releaseDate).format("DD MMM YYYY")})`}
      onCancel={handleClose}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button type="primary" onClick={handleClose}>
            Got it
          </Button>
        </div>
      }
    >
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </Modal>
  );
};

export default ReleaseNotesModal;
